"use client";

import React, { useEffect, useState } from "react";
import { CheckboxGroup, Label } from "react-aria-components";
import { Checkbox, Text } from "ui-components";

export interface IIWantToReachOutProps {
  label?: string;
  isRequired?: boolean;
  selectIWantToReachOut?: string;
  onIWantToReachOutChange?: (selectIWantToReachOut: string) => void;
  errorMessage?: string;
}

export function IWantToReachOut({
  label,
  isRequired,
  selectIWantToReachOut = "",
  onIWantToReachOutChange,
  errorMessage,
}: IIWantToReachOutProps): JSX.Element {
  const [selected, setSelected] = useState<string[]>(
    selectIWantToReachOut ? selectIWantToReachOut.split(",") : []
  );

  useEffect(() => {
    setSelected(selectIWantToReachOut ? selectIWantToReachOut.split(",") : []);
  }, [selectIWantToReachOut]);

  function handleSelectIWantToReachOut(values: string[]): void {
    const ordered = ["Graduates", "Professionals"];
    const sortedValues = ordered.filter((val) => values.includes(val));
    setSelected(sortedValues);
    onIWantToReachOutChange?.(sortedValues.join(","));
  }

  return (
    <CheckboxGroup
      value={selected}
      onChange={(value) => handleSelectIWantToReachOut(value)}
      className="flex flex-col gap-4"
    >
      <Label>
        <Text variant="small" align="left">
          {label}
          {isRequired && (
            <Text
              variant="small"
              intent="secondary"
              className="ml-1"
              align="left"
            >
              (required)
            </Text>
          )}
        </Text>
      </Label>
      <div className="flex flex-row flex-wrap gap-4">
        <Checkbox value="Graduates" label="Graduates" />
        <Checkbox value="Professionals" label="Professionals" />
      </div>
      {errorMessage && (
        <Text variant="small" intent="danger">
          {errorMessage}
        </Text>
      )}
    </CheckboxGroup>
  );
}
